module.exports = __webpack_public_path__ + "img/bill.31d1e136.svg";